<template>
  <v-card class="d-flex rounded-xl" flat :to="{ name: to}" @click="onClickHandler">
    
    <v-img :src="avatarUrl" class="rounded-lg" alt="alt" width="32px" v-if="avatarUrl" max-width="86px"> </v-img>

    <v-avatar class="rounded-lg" size="86" :color="`${color} lighten-5`" v-else>
      <v-icon :color="`${color} ${darken? 'darken-4': ''}`" large>{{icon}}</v-icon>
    </v-avatar>
    <v-sheet>
      <v-card-title class="text-body-2 text--secondary font-weight-regular" style="">
        {{title}}
      </v-card-title>
      <v-card-subtitle class="font-weight-bold text-subtitle-1">
        {{subtitle}}
      </v-card-subtitle>
    </v-sheet>
  </v-card>
</template>

<script>
import { VImg } from 'vuetify/lib';

export default {
  props: ["to", "icon", "title", "subtitle", "color", "darken", "href", "onClick", "avatarUrl"],

  methods: {
    onClickHandler() {
      if(this.onClick)
        this.onClick()
    }
  }
}
</script>